import { Box } from '@doltech/ui/lib/figma/Common/Box';
import MultipleChoiceQuestionResult from '@doltech/ui/lib/figma/MultipleChoiceQuestionResult/MultipleChoiceQuestionResult';
import { useDeviceDetect } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { ResultMultipleAnswerQuestionInstance } from '../../model/Question/result-multiple-answer-question.store';
import { ExtraQuestionProps } from './BaseQuestion';

const Main = styled(Box)``;

export interface MultipleQuestionResultProps extends React.HTMLAttributes<HTMLDivElement> {
  data: ResultMultipleAnswerQuestionInstance & ExtraQuestionProps;
  questionsInGroup?: any[];
}

const buildQuestionImage = (isImageIncluded, image, mobileImage, isMobile) => {
  if (!isImageIncluded) {
    return null;
  }
  if (isMobile) {
    return mobileImage || image;
  }
  // Desktop view.
  return image;
};

export const MultipleQuestionResult = observer((props: MultipleQuestionResultProps) => {
  const { data, questionsInGroup, ...rest } = props;
  const {
    question,
    options,
    no,
    userAnswer,
    markedStatus,
    correction,
    maxSelectedOptions,
    index,
    isImageIncluded = false,
    image,
    mobileImage,
  } = data;
  const { isMobile } = useDeviceDetect();

  return (
    <Main>
      <MultipleChoiceQuestionResult
        key={no}
        no={maxSelectedOptions === 1 ? no : no - index}
        question={question}
        correctKeys={[correction?.key]}
        userAnswerKeys={[userAnswer]}
        markedStatuses={[markedStatus]}
        options={options}
        maxSelectedOptions={maxSelectedOptions}
        image={buildQuestionImage(isImageIncluded, image, mobileImage, isMobile)}
        {...rest}
      />
    </Main>
  );
});
